import SettingsMetaData from "../../../../Components/Hooks/useSettingsMetaData";


const PriorityTask = () => {
  return (
    <SettingsMetaData propertyName={"priority"} viewPropertyName={"Priority"} />
  );
};
export default PriorityTask;